import type { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/react';
import type { FetchBaseQueryMeta } from '@reduxjs/toolkit/src/query';
import type { QueryReturnValue } from '@reduxjs/toolkit/src/query/baseQueryTypes';

import type { GetGridApiArgs } from '~services/api/grid/types';

export const serializeQueryArgs = (
	endpointName: string,
	queryArgs: Record<string, string | undefined | number>
) => {
	const orderedKeys = Object.keys(queryArgs).sort() as (keyof GetGridApiArgs)[];

	return `${endpointName}-${orderedKeys
		.map((key) => {
			const value = queryArgs[key];
			return `${key}-${value !== undefined ? value.toString() : ''}`;
		})
		.join('-')}`;
};

export const timeout = (
	ms: number
): Promise<
	QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>
> => {
	return new Promise((_, reject) => {
		setTimeout(() => {
			reject({ status: 'CUSTOM_ERROR' } as FetchBaseQueryError);
		}, ms);
	});
};
